module.exports = __webpack_public_path__ + "static/media/Back.3dd39670.svg";